"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
class XCToken {
    constructor(data) {
        this.data = data;
    }
    get address() {
        return this.data.id;
    }
    get name() {
        return this.data.name;
    }
    get symbol() {
        return this.data.symbol;
    }
    get decimals() {
        return this.data.decimals;
    }
    get totalSupply() {
        return new bignumber_js_1.BigNumber(this.data.totalSupply);
    }
    get globalAMPLSupply() {
        return new bignumber_js_1.BigNumber(this.data.globalAMPLSupply);
    }
}
exports.default = XCToken;
//# sourceMappingURL=XCToken.js.map